// extracted by mini-css-extract-plugin
export default {"wrapper":"ksUzEQ","bar":"WJPSQU","headline":"oVLB78","overriddenArrow":"sAeLTT","more":"GcW4rX","list":"j3eZYy"};